import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ClubSelectModal from "../../components/common/ClubSelectModal";

// Standalone route for "Select a Club" — reached via verifyRouting.js's
// routeAfterVerify when a caller doesn't pass an `onClubSelect` callback (the
// /login page, which doesn't render its own popups in-page for this case).
// HomePage.jsx's LoginCard instead renders ClubSelectModal directly as an
// in-page popup via that callback, without navigating here. A direct visit
// with no router state falls back to /login.
export default function ClubSelectPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const member = location.state?.member || null;
  const clubs = location.state?.clubs || [];

  useEffect(() => {
    if (!member) navigate("/login", { replace: true });
  }, [member, navigate]);

  if (!member) return null;

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <ClubSelectModal member={member} clubs={clubs} navigate={navigate} />
    </div>
  );
}
